<template>
    <div>
        <super-admin-instructions title="How to use jumpthink’s smart diagnostics"
                                  :instructions="cardsInstructions"
                                  @show-element="showInstructionsCard">
            <template v-slot:description>
                <div class="text-lg leading-6 mt-4">
                    <p>
                        Our smart diagnostics give you the freedom to easily survey your workforce to understand your organisation’s health. Either run a short, sharp 60-second staff survey as a temperature check, or a full, 30-minute health screening, for an in-depth understanding of where you’re at. Whichever you need, our tool will analyse the results at the click of a button, giving your organisation a PROPEL organisational health score in an instant.
                    </p>
                </div>
            </template>
            <template v-slot:instructions>
                <div class="card-instructions" v-for="(card, index) in cardsInstructions" :key="'card' + index">
                    <div class="flex gap-4 flex-col lg:flex-row lg:gap-12 pt-10" v-show="instructionsIndex === index">
                        <div class="flex-1">
                            <h4 class="font-bold text-2xl mb-4">{{ card.title }}</h4>
                            <p class="text-2xl leading-6">{{card.text }}</p>
                        </div>
                        <div class="flex-1">
                            <img :src="card.img" alt="" />
                        </div>
                    </div>
                </div>
            </template>
        </super-admin-instructions>

        <div class="p-6 mb-15 shadow-md">
            <div class="flex flex-col lg:flex-row">
                <h3 class="font-bold text-3xl dark:text-gray-200 pb-3 lg:pr-12 lg:pb-0">Create a diagnostic</h3>
                <div class="flex-1 text-lg leading-6">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    <div class="flex flex-col lg:flex-row lg:gap-5">
                        <a href="javascript:" class="underline">Understand your PROPEL score and method</a>
                        <a href="javascript:" class="underline">See how jumpthink helps organisation's like yours</a>
                    </div>
                </div>
            </div>
            <div class="divide-y divide-dark pt-4">
                <div class="pb-8 pt-4">
                    <div class="flex flex-col lg:flex-row justify-between lg:items-center mb-4">
                        <h4 class="font-bold text-2xl leading-6 pb-3 lg:pr-6 lg:pb-0">Run a 60-second Temperature Check</h4>
                        <inertia-link :href="route('tenant.survey.create', $page.props.tenant.id) + '?surveyTypeId=1'">
                            <jet-button :has-icon="true">New Temperature Check</jet-button>
                        </inertia-link>
                    </div>
                    <p class="text-lg leading-6">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                </div>
                <div class="pb-8 pt-4">
                    <div class="flex flex-col lg:flex-row justify-between lg:items-center mb-4">
                        <h4 class="font-bold text-2xl leading-6 pb-3 lg:pr-6 lg:pb-0">Run a 30-minute Health Screening</h4>
                        <inertia-link :href="route('tenant.survey.create', $page.props.tenant.id) + '?surveyTypeId=2'">
                            <jet-button :has-icon="true">New Health Screening</jet-button>
                        </inertia-link>
                    </div>
                    <p class="text-lg leading-6">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                </div>
            </div>
        </div>

        <div class="flex flex-wrap lg:flex-nowrap gap-4 mb-15">
            <div class="w-full lg:w-1/2 p-6 shadow-md bg-green-500 rounded-md">
                <h3 class="font-bold text-3xl text-green-900">Understand your PROPEL score and method</h3>
                <p class="text-lg leading-6 text-green-900">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                <a href="javascript:" class="mt-6 px-4 py-2 inline-flex items-center text-lg leading-5 rounded-md text-white bg-green-900 active:bg-green-900 hover:bg-green-700 focus:outline-none focus:shadow-none disabled:opacity-25 transition transition-all duration-150">
                    Learn more
                    <svg class="w-5 h-5 ml-2" fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                        <path d="M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"/>
                    </svg>
                </a>
            </div>
            <div class="w-full lg:w-1/2 p-6 shadow-md bg-yellow-500 rounded-md">
                <h3 class="font-bold text-3xl text-yellow-900">See how Jumpthink helps organisation's like yours</h3>
                <p class="text-lg leading-6 text-yellow-900">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                <a href="javascript:" class="mt-6 px-4 py-2 inline-flex items-center text-lg leading-5 rounded-md text-white bg-yellow-900 active:bg-yellow-900 hover:bg-yellow-850 focus:outline-none focus:shadow-none disabled:opacity-25 transition transition-all duration-150">
                    Learn more
                    <svg class="w-5 h-5 ml-2" fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                        <path d="M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"/>
                    </svg>
                </a>
            </div>
        </div>

        <div class="p-6 shadow-md rounded-md">
            <div class="flex justify-between items-start">
                <h3 class="font-bold text-3xl dark:text-gray-200 pr-6">Account summary</h3>
                <p class="text-lg underline cursor-pointer" @click="toggleShowAccountSummary">
                    {{ showAccountSummary ? 'Hide' : 'Show' }}
                </p>
            </div>
            <div v-show="showAccountSummary" class="pt-7">
                <div class="grid md:grid-cols-2 xl:grid-cols-4 gap-4">
                    <div class="rounded-md bg-light flex items-center p-4">
                        <div class="flex items-center justify-center mr-4 rounded-full text-xl font-bold w-12 h-12 text-white bg-dark">
                            {{ totalSurveys }}
                        </div>
                        <p class="flex-1 text-xl font-bold leading-6">Total surveys</p>
                    </div>
                    <div class="rounded-md bg-light flex items-center p-4">
                        <div class="flex items-center justify-center mr-4 rounded-full text-xl font-bold w-12 h-12 text-white bg-dark">
                            {{ liveSurveys }}
                        </div>
                        <p class="flex-1 text-xl font-bold leading-6">Live surveys</p>
                    </div>
                    <div class="rounded-md bg-light flex items-center p-4">
                        <div class="flex items-center justify-center mr-4 rounded-full text-xl font-bold w-12 h-12 text-white bg-dark">
                            {{ closedSurveys }}
                        </div>
                        <p class="flex-1 text-xl font-bold leading-6">Closed surveys</p>
                    </div>
                    <div class="rounded-md bg-light flex items-center p-4">
                        <div class="flex items-center justify-center mr-4 rounded-full text-xl font-bold w-12 h-12 text-white bg-dark">
                            {{ averageResponseRate !== null ? averageResponseRate + '%' : 'N/A' }}
                        </div>
                        <p class="flex-1 text-xl font-bold leading-6">Average response rate</p>
                    </div>
                </div>

                <div class="pt-6">
                    <template v-if="recentSurveys.length">
                        <h4 class="font-bold text-2xl leading-6 pb-7">Recent Surveys</h4>
                        <survey-card
                            v-for="(survey, surveyIndex) in recentSurveys"
                            :key="'survey-' + surveyIndex"
                        >
                            <template v-slot:data>
                                <div>
                                    <p class="text-2xl leading-6 font-bold mb-2">{{ survey.name }}</p>
                                    <p>Created: {{ moment(survey.created_at).format('DD-MM-YYYY HH:mm') }}</p>
                                    <p v-if="!tenant">
                                        {{ survey.tenant ? survey.tenant.name : '' }}
                                    </p>
                                </div>
                                <div class="xl:text-right">
                                    <p class="text-2xl">{{ survey.survey_type.type }}</p>
                                </div>
                            </template>
                            <template v-slot:actions>
                                <pill :type="pillColorsByStatus[survey.status]">
                                    {{ survey.current_status }}
                                    <template v-if="survey.status === 1">
                                        for {{ moment(survey.live_at).format("DD-MM-YYYY HH:mm") }}
                                    </template>
                                </pill>

                                <inertia-link
                                    :href="route('tenant.survey.preview', {survey: survey.id})"
                                    title="Preview Survey"
                                    class="flex items-center font-bold text-lg leading-6"
                                    aria-label="Show"
                                >
                                    <svg class="mr-2 w-6 h-6" fill="dark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"/>
                                    </svg>
                                    Preview Survey
                                </inertia-link>
                                <template v-if="survey.isActive">
                                    <button title="Copy survey URL"
                                            @click.prevent="copyToClipboard(survey)"
                                            class="flex items-center font-bold text-lg leading-6">
                                        <svg class="mr-2 w-6 h-6" fill="dark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path d="M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"/>
                                        </svg>
                                        Copy survey URL
                                    </button>
                                </template>
                                <inertia-link v-if="survey.status !== 0"
                                              :href="route('tenant.survey.show', {survey: survey.id})"
                                              title="Survey details"
                                              class="flex items-center font-bold text-lg leading-6"
                                              aria-label="Survey details"
                                >
                                    <svg class="mr-2 w-6 h-6" fill="dark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                                        <path d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"/>
                                    </svg>
                                    Survey details
                                </inertia-link>
                            </template>
                        </survey-card>
                    </template>
                    <template v-else>
                        <p class="text-2xl font-bold leading-6">No recent surveys.</p>
                    </template>
                </div>
            </div>
        </div>



<!--         <div
            class="mt-3 mb-2 px-4 py-2 text-md font-semibold flex items-center justify-between w-full rounded-md bg-gray-200 dark:bg-gray-600 dark:text-white focus:outline-none">
            Account summary
        </div>
        <div class="flex flex-wrap justify-center -mx-2">
            &lt;!&ndash; Card &ndash;&gt;
            <dashboard-card class="w-1/2 xl:w-1/4" circle-color="teal">
                <template v-slot:circle>
                    {{ totalSurveys }}
                </template>
                <template v-slot:content>
                    <p class="text-md font-semibold text-gray-700 dark:text-gray-200">
                        Total
                    </p>
                </template>
            </dashboard-card>
            &lt;!&ndash; Card &ndash;&gt;
            <dashboard-card class="w-1/2 xl:w-1/4" circle-color="indigo">
                <template v-slot:circle>
                    {{ liveSurveys }}
                </template>
                <template v-slot:content>
                    <p class="text-md font-semibold text-gray-700 dark:text-gray-200">
                        Live
                    </p>
                </template>
            </dashboard-card>
            &lt;!&ndash; Card &ndash;&gt;
            <dashboard-card class="w-1/2 xl:w-1/4" circle-color="red">
                <template v-slot:circle>
                    {{ closedSurveys }}
                </template>
                <template v-slot:content>
                    <p class="text-md font-semibold text-gray-700 dark:text-gray-200">
                        Closed
                    </p>
                </template>
            </dashboard-card>
            &lt;!&ndash; Card &ndash;&gt;
            <dashboard-card class="w-1/2 xl:w-1/4" :circle-color="averageResponseRateColor">
                <template v-slot:circle>
                    {{ averageResponseRate !== null ? averageResponseRate + '%' : 'N/A' }}
                </template>
                <template v-slot:content>
                    <p class="text-md font-semibold text-gray-700 dark:text-gray-200">
                        Average Response Rate
                    </p>
                </template>
            </dashboard-card>
        </div>

        <div class="flex -mx-2 py-4">
            <div class="w-1/2 px-2">
                <a href="#"
                   class="block w-full text-center text-lg items-center px-4 py-6 text-white bg-purple-700 rounded-lg shadow-xs dark:bg-bg-purple-700 focus:outline-none">
                    View our accelerator Programmes
                </a>
            </div>
            <div class="w-1/2 px-2">
                <a href="#"
                   class="block w-full text-center text-lg items-center px-4 py-6 text-white bg-purple-700 rounded-lg shadow-xs dark:bg-bg-purple-700 focus:outline-none">
                    Book a free Organisational Development Call
                </a>
            </div>
        </div>

        <div
            class="mt-6 mb-4 px-4 py-2 text-md font-semibold flex items-center justify-between w-full rounded-md bg-gray-200 dark:bg-gray-600 dark:text-white focus:outline-none">
            Recent Surveys
        </div>

        <div class="w-full mb-8 overflow-hidden rounded-lg shadow-xs">
            <div class="w-full overflow-x-auto">
                <template v-if="recentSurveyScores.length">
                    <survey-score-explorer v-for="(surveyScores, surveyIndex) in recentSurveyScores"
                                           :key="'surveyScores-' + surveyIndex"
                                           :surveyScores=surveyScores
                    ></survey-score-explorer>
                </template>
                <template v-else>
                    <p class="text-md font-semibold text-gray-700 dark:text-gray-200">
                        No recent surveys.
                    </p>
                </template>
            </div>
        </div>

        <div class="flex -mx-2 py-4">
            <div class="w-1/2 px-2">
                <a class="flex items-center justify-center p-4 mb-8 text-sm font-semibold text-purple-100 bg-purple-600 rounded-lg shadow-md focus:outline-none focus:shadow-outline-purple"
                   href="https://github.com/estevanmaito/windmill-dashboard">
                    <div class="flex items-center">
                        <span>Understand more about the PROPEL method</span>
                    </div>
                    <span class="ml-4">→</span>
                </a>
            </div>
            <div class="w-1/2 px-2">
                <a class="flex items-center justify-center p-4 mb-8 text-sm font-semibold text-purple-100 bg-purple-600 rounded-lg shadow-md focus:outline-none focus:shadow-outline-purple"
                   href="https://github.com/estevanmaito/windmill-dashboard">
                    <div class="flex items-center">
                        <span>Read more about how jumpthink works</span>
                    </div>
                    <span class="ml-4">→</span>
                </a>
            </div>
        </div>-->
    </div>
</template>

<script>
import DashboardCard from "@/Components/DashboardCard";
import SuperAdminInstructions from "@/Components/SuperAdminDashboard/SuperAdminInstructions";
import SurveyScoreExplorer from "@/Components/SurveyAdminDashboard/SurveyScoreExplorer";
import SurveyCard from "@/Components/SurveyCard";
import JetButton from "@/Jetstream/Button";
import Pill from "@/Jetstream/Pill";
import {usePage} from "@inertiajs/inertia-vue3";
import {onMounted, ref} from "vue";
import {inject} from "vue";
import {Inertia} from "@inertiajs/inertia";
import useClipboard from "vue-clipboard3";

export default {
    name: "SurveyAdminDashboard",
    components: {
        SuperAdminInstructions,
        SurveyScoreExplorer,
        DashboardCard,
        SurveyCard,
        JetButton,
        Pill,
    },
    props: {
        recentSurveyScores: {
            type: Array,
            default: [],
        },
        recentSurveys: Object,
    },
    setup(props) {
        const {
            totalSurveys,
            liveSurveys,
            closedSurveys,
            averageResponseRate,
            recentSurveyScores,
        } = usePage().props.value;

        let averageResponseRateColor = null;
        if (averageResponseRate !== null) {
            if (averageResponseRate < 34) {
                averageResponseRateColor = 'red';
            } else if (averageResponseRate < 68) {
                averageResponseRateColor = 'orange';
            } else {
                averageResponseRateColor = 'green';
            }
        }

        const showAccountSummary = ref(true);
        const toggleShowAccountSummary = () => {
            showAccountSummary.value = !showAccountSummary.value;
        };

        const cardsInstructions = [
            {
                title: "Step 1 title",
                text: "Customise your diagnostic with your logo, intro text and any custom fields you need.",
                img: "http://placehold.jp/570x190.png"
            },
            {
                title: "Step 2 title",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Delectus, quod!",
                img: "http://placehold.jp/570x190.png"
            },
            {
                title: "Step 3 title",
                text: "Facere, ratione, veritatis? Debitis dignissimos distinctio explicabo fuga inventore modi odio perferendis!",
                img: "http://placehold.jp/570x190.png"
            }
        ]

        const instructionsIndex = ref(0);
        const showInstructionsCard = (value) => instructionsIndex.value = value;

        const {toClipboard} = useClipboard();

        const $toast = inject('$toast');

        const copyToClipboard = async (survey) => {
            let urlString;
            try {
                if (survey.custom_url) {
                    urlString = route('tenant.survey.fill.custom_url', {
                        tenant: survey.tenant_id,
                        customUrl: survey.custom_url,
                    });
                } else {
                    urlString = route('tenant.survey.fill.token', {
                        tenant: survey.tenant_id,
                        token: survey.token,
                    });
                }
                await toClipboard(urlString);
                $toast('Copied to clipboard', {type: "success"});
            } catch (e) {
                console.error(e)
            }
        };

        const canManageSurveys = usePage().props.value.allUserPermissions
            && usePage().props.value.allUserPermissions.indexOf('manage surveys') !== -1;

        const tenant = usePage().props.value.tenant;

        const pillColorsByStatus = [
            'danger', //draft 0
            'warning', //scheduled 1
            'success', //live 2
            'danger', //no respondent slots 3
            'info', //closed 4
            'success', //reopened 5
        ];

        return {
            totalSurveys,
            liveSurveys,
            closedSurveys,
            averageResponseRate,
            recentSurveyScores,
            averageResponseRateColor,
            cardsInstructions,
            showAccountSummary,
            toggleShowAccountSummary,
            instructionsIndex,
            showInstructionsCard,
            tenant,
            pillColorsByStatus,
            copyToClipboard,
        }
    }
}
</script>

<style scoped>

</style>
